import { c as _c } from "react/compiler-runtime";
import { formatDateTime } from "@/components/user/xtdh/utils/xtdhGrantFormatters";
export function GrantExpiryBadge(t0) {
  const $ = _c(5);
  const {
    validUntil
  } = t0;
  if (!validUntil) {
    return null;
  }
  let t1;
  if ($[0] !== validUntil) {
    const date = new Date(validUntil);
    date.setDate(date.getDate() - 1);
    t1 = formatDateTime(date.getTime(), {
      includeTime: false
    });
    $[0] = validUntil;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const label = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="tw-text-iron-500">Last grant</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label) {
    t3 = <div className="tw-flex tw-items-center tw-gap-1.5 tw-text-xs">{t2}<span className="tw-font-medium tw-text-iron-300">{label}</span></div>;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}